import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18nify';
import EditModal from '../modal/EditModal';
import AddSharedThreatPolicy from '../../containers/shared_policies/AddSharedThreatPolicy';

const AddSharedThreatPolicyModal = ({
  showModal,
  closeDialog,
  buttonAction,
  disabled,
}) => (
  <EditModal
    title={translate('components.mspSharedAtp.sharedThreatPolicy')}
    showModal={showModal}
    buttonAction={buttonAction}
    closeDialog={closeDialog}
    saveBtnText={translate('shared.save')}
    disabled={disabled}
  >
    <AddSharedThreatPolicy />
  </EditModal>
);

AddSharedThreatPolicyModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  buttonAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideNetwork: PropTypes.bool,
};

AddSharedThreatPolicyModal.defaultProps = {
  disabled: false,
};

export default AddSharedThreatPolicyModal;
